import { createContext } from "react";

const AnnotationContext = createContext();

export default AnnotationContext;